// extracted by mini-css-extract-plugin
export default {"wrapper":"DropColumn_wrapper__ljrfp","isOver":"DropColumn_isOver__BfCQ4","footer":"DropColumn_footer__KXo4V","list":"DropColumn_list__MBMIX"};